import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-congrats-voucher-stamp',
  templateUrl: './congrats-voucher-stamp.component.html',
  styleUrls: ['./congrats-voucher-stamp.component.scss'],
})
export class CongratsVoucherStampComponent  implements OnInit {
  @Input() mode:'button'
  constructor() { }

  ngOnInit() {}

}
